exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-class{\n    font-family: 'Open Sans';\n    font-size: 24px;\n    text-align: center;\n}\n.text-class{\n    font-family: 'Open Sans';\n    font-size: 14px;\n    text-align: center;\n}\n.register-container{\n    width: 540px;\n    padding: 16px 0;\n    border-radius: 4px;\n    background-color: #ffffff;\n    background-size: cover;\n    box-shadow: 0px 2px 4px rgba(0,0,0,0.1);\n\n    display: -ms-flexbox;\n\n    display: flex;\n    -ms-flex-line-pack: center;\n        align-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n.explanation-sub{\n    font-family: 'Open Sans';\n    font-size: 14px;\n    color: #8e8fa6;\n}\n.proceed-btn{\n    width: 130px;\n    height: 40px;\n    font-family: 'Open Sans';\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 8px;\n}\n.link-signup{\n    text-decoration: none;\n    font-family: 'Open Sans';\n    font-size: 14px;\n}\n.link-signup:hover{\n    cursor: pointer;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/self-register/self-register-validate.component.css
// module id = 807
// module chunks = 0